import {
  IoCheckmarkOutline,
  IoCloseOutline,
  IoCloseSharp,
} from "react-icons/io5";
import Button from "../../../components/Button/button";
import {
  BlueTitle,
  ContainerInput,
  ModalBody,
  ModalContainer,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "../../../shared/styles/global.styles";
import {
  ContainerCheckbox,
  LabelCheckbox,
  Switch,
  SwitchContainer,
  SwitchInput,
  SwitchLabel,
  SwitchRow,
  SwitchSpan,
} from "./styles";
import React, { useState } from "react";
import Swal from "sweetalert2";
import { Label } from "../../../components/Label/styles";
import { ReajusteValoresFinanceirosDto } from "../../../shared/dtos/DadosFinanceiros.dto";
import InputComponent from "../../../components/Input/input";
import { Col, Row } from "react-bootstrap";
import { Checkbox } from "@mui/material";

interface Props {
  reajusteValores: ReajusteValoresFinanceirosDto;
  setReajusteValores: React.Dispatch<
    React.SetStateAction<ReajusteValoresFinanceirosDto>
  >;
  show: boolean;
  onClose: () => void;
  onSubmit: (reajusteData: ReajusteValoresFinanceirosDto) => void;
}

const ReajusteModal: React.FC<Props> = ({
  reajusteValores,
  setReajusteValores,
  show,
  onClose,
  onSubmit,
}) => {
  const [isPercentage, setIsPercentage] = useState<boolean>(
    reajusteValores.type === "PERCENTAGE"
  );
  const [isMonetary, setIsMonetary] = useState<boolean>(
    reajusteValores.type === "VALUE"
  );
  const [invalidFields, setInvalidFields] = useState<string[]>([]);

  const [reajusteValoresModal, setReajusteValoresModal] =
    useState<ReajusteValoresFinanceirosDto>({
      type: reajusteValores.type,
      valueTitular: reajusteValores.valueTitular,
      valueDependente: reajusteValores.valueDependente,
      dateReajuste: reajusteValores.dateReajuste,
      idsDadosFinanceiros: reajusteValores.idsDadosFinanceiros,
      roundValue: reajusteValores.roundValue,
      inputTitular: reajusteValores.inputTitular,
      inputDependente: reajusteValores.inputDependente,
    });

  const validate = async () => {
    const newInvalidFields: string[] = [];
    // if (
    //   !reajusteValoresModal.valueTitular ||
    //   reajusteValoresModal.valueTitular <= 0
    // ) {
    //   newInvalidFields.push("valueTitular");
    // }
    // if (
    //   !reajusteValoresModal.valueDependente ||
    //   reajusteValoresModal.valueDependente <= 0
    // ) {
    //   newInvalidFields.push("valueDependente");
    // }
    if (!reajusteValoresModal.dateReajuste) {
      newInvalidFields.push("dateReajuste");
    }

    if (newInvalidFields.length > 0) {
      setInvalidFields(newInvalidFields);

      Swal.fire({
        icon: "error",
        title: "Erro nos campos",
        text: "Por favor, preencha todos os campos obrigatórios.",
        confirmButtonText: "OK",
      });
      return;
    }

    setInvalidFields([]);
    setReajusteValores(reajusteValoresModal);
    onSubmit(reajusteValoresModal);
    onClose();
  };

  const clearError = (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => {
    const { name } = event.target;

    setInvalidFields((prev) => prev.filter((field) => field !== name));
  };

  const formatValue = (value: string, isPercentage: boolean): string => {

    // Remove qualquer caractere não numérico
    const cleanValue = value.replace(/[^\d]/g, "");

    // Se vazio ou apenas "0", retorna formato inicial
    if (!cleanValue || cleanValue === "0") {
      return isPercentage ? "0,00%" : "R$0,00";
    }

    // Converte para número (tratando como centavos)
    let numberValue = parseInt(cleanValue) / 100;

    // Formata com duas casas decimais e separador de milhar
    const formattedValue = numberValue
      .toFixed(2)
      .replace(".", ",")
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    // Adiciona o prefixo apropriado (R$ ou %)
    const result = isPercentage ? `${formattedValue}%` : `R$${formattedValue}`;

    return result;
  };

  const activeInputValue = (setInput: any, inputValue: boolean) => {
    setInput(!inputValue);
  };

  return (
    <ModalContainer show={show}>
      <ModalContent width={45}>
        <Button
          type="button"
          schemaButton="x-close"
          action={() => onClose()}
          icon={<IoCloseSharp size={30} />}
          position="absolute"
          top={10}
          right={10}
        />
        <ModalHeader>
          <BlueTitle>Reajuste de Valores Financeiros</BlueTitle>
        </ModalHeader>
        <ModalBody>
          <Label htmlFor="tipoReajuste">Tipo do Reajuste</Label>
          <SwitchRow>
            <SwitchContainer key="Reajuste-Monetario">
              <Switch>
                <SwitchInput
                  type="checkbox"
                  id={`reajuste-monetario`}
                  checked={isMonetary}
                  onChange={(e) => {
                    if (!isMonetary !== false && isPercentage === true) {
                      setIsMonetary(!isMonetary);
                      setIsPercentage(false);
                      setReajusteValoresModal({
                        ...reajusteValoresModal,
                        type: "VALUE",
                      });
                    }
                  }}
                />

                <SwitchSpan />
              </Switch>
              <LabelCheckbox htmlFor={`reajuste-monetario`}>Valor</LabelCheckbox>
            </SwitchContainer>
            <SwitchContainer key="Reajuste-percentual">
              <Switch>
                <SwitchInput
                  type="checkbox"
                  id={`reajuste-percentual`}
                  checked={isPercentage}
                  onChange={(e) => {
                    if (!isPercentage !== false && isMonetary === true) {
                      setIsPercentage(!isPercentage);
                      setIsMonetary(false);
                      setReajusteValoresModal({
                        ...reajusteValoresModal,
                        type: "PERCENTAGE",
                      });
                    }
                  }}
                />

                <SwitchSpan />
              </Switch>
              <LabelCheckbox htmlFor={`reajuste-percentual`}>
                Porcentagem
              </LabelCheckbox>
            </SwitchContainer>
          </SwitchRow>
          <Row>
            <Col>
              <Label htmlFor="valorTitular">Valor titular</Label>
              <InputComponent
                type="text"
                name="valorTitular"
                id="valorTitular"
                value={formatValue(
                  reajusteValoresModal.valueTitular?.toString() || "-",
                  isPercentage
                )}
                onChange={(e) => {
                  const rawValue = e.target.value.replace(/[^\d]/g, "");
                  const numberValue = rawValue
                    ? parseInt(rawValue).toFixed(2)
                    : 0;
                  setReajusteValoresModal({
                    ...reajusteValoresModal,
                    valueTitular: Number(numberValue),
                  });
                  clearError(e);
                }}
                placeholder="Novo valor titular"
                color="black"
                width={Number("100%")}
                maxLength={50}
                errorMessage={
                  invalidFields.includes("valueTitular")
                    ? "Valor para o titular é obrigatório"
                    : ""
                }
                disabled={reajusteValoresModal.inputTitular}
              />
              <ContainerCheckbox>
                <Checkbox
                  checked={reajusteValoresModal.inputTitular}
                  onChange={(e) => {
                    setReajusteValoresModal({
                      ...reajusteValoresModal,
                      inputTitular: e.target.checked,
                      valueTitular: undefined,
                    });
                  }}
                />
                <LabelCheckbox htmlFor={`reajuste-monetario`}>
                  Não ajustar titular
                </LabelCheckbox>
              </ContainerCheckbox>
            </Col>
            <Col>
              <Label htmlFor="valorTitular">Valor dependente</Label>
              <InputComponent
                type="text"
                name="valorDependente"
                id="valorDependente"
                value={formatValue(
                  reajusteValoresModal.valueDependente?.toString() || "-",
                  isPercentage
                )}
                onChange={(e) => {
                  const rawValue = e.target.value.replace(/[^\d]/g, "");
                  const numberValue = rawValue
                    ? parseInt(rawValue).toFixed(2)
                    : 0;
                  setReajusteValoresModal({
                    ...reajusteValoresModal,
                    valueDependente: Number(numberValue),
                  });
                  clearError(e);
                }}
                placeholder="Novo valor dependente"
                color="black"
                width={Number("100%")}
                maxLength={50}
                errorMessage={
                  invalidFields.includes("valueDependente")
                    ? "Valor para o dependente é obrigatório"
                    : ""
                }
                disabled={reajusteValoresModal.inputDependente}
              />
              <ContainerCheckbox>
                <Checkbox
                  checked={reajusteValoresModal.inputDependente}
                  onChange={(e) => {
                    setReajusteValoresModal({
                      ...reajusteValoresModal,
                      inputDependente: e.target.checked,
                      valueDependente: undefined,
                    });
                  }}
                />
                <LabelCheckbox htmlFor={`reajuste-monetario`}>
                  Não ajustar dependente
                </LabelCheckbox>
              </ContainerCheckbox>
            </Col>
          </Row>

          <Label htmlFor="valorTitular">Data do reajuste</Label>
          <InputComponent
            type="date"
            name="dataReajuste"
            id="dataReajuste"
            value={reajusteValoresModal.dateReajuste}
            onChange={(e) => {
              setReajusteValoresModal({
                ...reajusteValoresModal,
                dateReajuste: e.target.value,
              });
              clearError(e);
            }}
            placeholder="Data do reajuste"
            color="black"
            width={Number("100%")}
            maxLength={50}
            errorMessage={
              invalidFields.includes("dateReajuste")
                ? "Data do reajuste é obrigatório"
                : ""
            }
          />
          <SwitchContainer key="arrendondarValor">
            <Switch>
              <SwitchInput
                type="checkbox"
                id={`arrendondarValor`}
                checked={reajusteValoresModal.roundValue}
                onChange={(e) => {
                  setReajusteValoresModal({
                    ...reajusteValoresModal,
                    roundValue: !reajusteValoresModal.roundValue,
                  });
                }}
              />
              <SwitchSpan />
            </Switch>
            <LabelCheckbox htmlFor={`arrendondarValor`}>
              Arredondar valor
            </LabelCheckbox>
          </SwitchContainer>
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            action={() => {
              validate();
            }}
            schemaButton="full-primary"
          >
            Reajustar dados financeiros
          </Button>
        </ModalFooter>
      </ModalContent>
    </ModalContainer>
  );
};

export default ReajusteModal;
